// getNewItemPath TO DO
import { format } from 'date-fns';

import { isEmpty } from 'src/utils';
import { mapNewItem } from '../mappers';
import { clearQuery } from './query';

export const getItemWithUpdatedPath = (movingItem, destinationItem) => {
  const newPath = destinationItem.path
    ? [
        ...destinationItem.path,
        { id: destinationItem.id, label: destinationItem.label },
      ]
    : destinationItem.id !== 0
    ? [{ id: destinationItem.id, label: destinationItem.label }]
    : undefined;

  return {
    ...movingItem,
    path: newPath,
  };
};

export const setFolderChildren = (id, folder, children) => {
  if (folder.id === id) {
    return {
      ...folder,
      loaded: true,
      children,
    };
  }

  if (folder.id !== id && !isEmpty(folder.children)) {
    return {
      ...folder,
      children: folder.children.map(child => {
        return setFolderChildren(id, child, children);
      }),
    };
  }
  return folder;
};

export const getUpdatedRepo = (currentData, updatedDataByFilter, filter) => {
  const updateData = {
    ...currentData,
  };

  Object.keys(currentData).forEach(key => {
    if (key === filter) {
      updateData[filter] = updatedDataByFilter;
    }
  });

  return updateData;
};

export const findParentIdByPath = item => {
  if (item.path && item.path.length > 1) {
    return item.path[item.path.length - 1].id;
  }
  if (!item.path || !item.path[0]) {
    return 0;
  }

  return item.path[0].id || 0;
};

export const findAndAddChild = (tree, parent_id, new_child) => {
  if (parent_id === 0) {
    return [mapNewItem(new_child), ...tree];
  }
  return tree.map(item => {
    if (item.id !== parent_id) {
      if (!item.children || item.children.length === 0) {
        return item;
      }

      return {
        ...item,
        children: findAndAddChild(item.children, parent_id, new_child),
      };
    }

    if (!item.children) {
      return {
        ...item,
        children: [getItemWithUpdatedPath(mapNewItem(new_child), item)],
      };
    }

    return {
      ...item,
      children: [
        getItemWithUpdatedPath(mapNewItem(new_child), item),
        ...item.children,
      ],
    };
  });
};

export const findAndRemoveChild = (tree, parent_id, child_id) => {
  if (Number(parent_id) === 0) {
    return tree.filter(item => item.id !== child_id);
  }

  return tree.map(item => {
    if (item.id !== parent_id) {
      if (!item.children || item.children.length === 0) {
        return item;
      }

      return {
        ...item,
        children: findAndRemoveChild(item.children, parent_id, child_id),
      };
    }

    return {
      ...item,
      children: item.children.filter(item => item.id !== child_id),
    };
  });
};

export const findAndUpdateLabel = (tree, item_id, new_label) => {
  return tree.map(item => {
    if (item.id !== item_id) {
      if (!item.children || item.children.length === 0) {
        return item;
      }

      return {
        ...item,
        children: findAndUpdateLabel(item.children, item_id, new_label),
      };
    }

    return {
      ...item,
      label: new_label,
    };
  });
};

export const createTmpQueryLabel = (query, queryEntitiesInfos) => {
  const tmpQueryItems = [];

  query.arguments_list.forEach(item => {
    if (item.type !== 'block') {
      if (tmpQueryItems.length < 3) {
        tmpQueryItems.push(
          queryEntitiesInfos[`${item.type}_${item.id}`].label
            .replace(' - ', '-')
            .split(' ')
            .join('-')
        );
      }

      return;
    }

    return item.arguments_list.forEach(subItem => {
      if (subItem.type !== 'block') {
        if (tmpQueryItems.length < 3) {
          const queryEntity =
            queryEntitiesInfos[`${subItem.type}_${subItem.id}`];
          const queryEntityLabel = queryEntity?.label;
          if (queryEntityLabel) {
            tmpQueryItems.push(queryEntityLabel.split(' ').join('-'));
          }
        }
      }
    });
  });

  const tmpQueryDate = format(new Date(), 'MM_dd_HH_mm');

  const tmpQueryItemsLabels = tmpQueryItems
    .join('_')
    .trim()
    .toLowerCase();

  let queryLabel = `${tmpQueryItemsLabels}`;

  // Query label must not be longer than 100 characters
  if (queryLabel && queryLabel.length > 88) {
    queryLabel = queryLabel.substring(0, 88);
  }
  queryLabel = `${queryLabel}_${tmpQueryDate}`;
  return queryLabel;
};

export function prepareNewAudience(queryBuilder) {
  const newAudience = {
    query_type: queryBuilder.query_type,
    label:
      queryBuilder.label ||
      createTmpQueryLabel(
        queryBuilder.target_query,
        queryBuilder.queryEntitiesInfos
      ),
    target_query: queryBuilder.target_query
      ? clearQuery(queryBuilder.target_query)
      : null,
    base_query: queryBuilder.base_query.query_block
      ? {
          whole_population: false,
          query_block: clearQuery(queryBuilder.base_query.query_block),
        }
      : { whole_population: true, query_block: null },
    target_membership_id: queryBuilder.target_membership_id,
    data_source: queryBuilder.data_source,
  };

  if (queryBuilder.query_type === 'interest') {
    return newAudience;
  }

  return {
    ...newAudience,
    audience_timeframe: queryBuilder.audience_timeframe,
    results_timeframe: queryBuilder.results_timeframe || 52,
  };
}

export const conversationLabel = queryBuilder => {
  const queries = Object.values(queryBuilder.conversationQueries || [])
    .filter(q => !!q)
    .slice(0, 3)
    .map(q => q.substring(0, 20).trim())
    .join('_');
  return `${queries}_${format(new Date(), 'MM_dd_HH_mm')}`;
};

export function prepareNewConversation(queryBuilder) {
  const query = clearQuery(queryBuilder.target_query);
  return {
    query_type: 'conversation',
    label: conversationLabel(queryBuilder),
    audience_timeframe: queryBuilder.audience_timeframe,
    results_timeframe: queryBuilder.audience_timeframe,
    query,
    target_query: query,
    base_query: { whole_population: true, query_block: null },
  };
}
